import React from 'react'
// import './Auth.css'

const AboutAuth = () => {
  return (
    <div className='auth-container-1'>
      <h1>Join the Stack OverFlow Community</h1>
      <p>Get unStuck -Ask a question</p>
      <p>Unlock new privilleges like voting and commenting</p>
      <p>Save Your favorite tags,filters and jobs</p>
      <p>Earn reputaion and badges</p>
      <p style={{color:"#666767",fontSize:"13px"}}>Collaborate and share knowledge with a private group for</p>
      <p style={{color:"#007ac6",fontSize:"13px"}}>Get Stuck Overflow for Teams free for up to 50 users</p>
        </div>
  )
}

export default AboutAuth